import { SVGProps } from "react";

const KpiCrossIcon = ({
  width = 20,
  height = 20,
  color = "#E3002D",
  ...props
}: SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18.3333 18.3333"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.16667 0C4.11196 0 0 4.11196 0 9.16667C0 14.2214 4.11196 18.3333 9.16667 18.3333C14.2214 18.3333 18.3333 14.2214 18.3333 9.16667C18.3333 4.11196 14.2214 0 9.16667 0ZM12.5423 11.4621C12.841 11.7609 12.841 12.2436 12.5423 12.5423C12.3934 12.6913 12.1978 12.7661 12.0022 12.7661C11.8066 12.7661 11.6111 12.6913 11.4621 12.5423L9.16667 10.2468L6.87122 12.5423C6.72226 12.6913 6.52672 12.7661 6.33118 12.7661C6.1355 12.7661 5.93995 12.6913 5.79099 12.5423C5.49236 12.2436 5.49236 11.7609 5.79099 11.4621L8.08657 9.16667L5.79099 6.87122C5.49236 6.57246 5.49236 6.08976 5.79099 5.79099C6.08976 5.49236 6.57246 5.49236 6.87122 5.79099L9.16667 8.08657L11.4621 5.79099C11.7609 5.49236 12.2436 5.49236 12.5423 5.79099C12.841 6.08976 12.841 6.57246 12.5423 6.87122L10.2468 9.16667L12.5423 11.4621Z"
      fill={color}
    />
  </svg>
);

export default KpiCrossIcon;
